export interface NavbarLink {
    href: string;
    labelKey:
        | "bulmacalar"
        | "positional"
        | "tactical"
        | "puzzleRush"
        | "puzzleBattle"
        | "egitimler"
        | "eglence"
        | "etkinlikler"
        | "haberler"
        | "urunler";
}

export const puzzleLinks: NavbarLink[] = [
    {
        href: "/bulmacalar?gm=puzzles&pt=taktiksel",
        labelKey: "tactical",
    },
    {
        href: "/bulmacalar?gm=puzzles&pt=pozisyonel",
        labelKey: "positional",
    },
    { href: "/bulmacalar?gm=puzzleRush", labelKey: "puzzleRush" },
    { href: "/bulmacalar?gm=puzzleBattle", labelKey: "puzzleBattle" },
];

export const videoLinks: NavbarLink[] = [
    { href: "/seri/egitimler", labelKey: "egitimler" },
    { href: "/seri/eglence", labelKey: "eglence" },
];

export const communityLinks: NavbarLink[] = [
    { href: "/haberler", labelKey: "haberler" },
    { href: "/etkinlikler", labelKey: "etkinlikler" },
];

export const storeLink: NavbarLink = {
    href: "/urunler",
    labelKey: "urunler",
};
